<template>
  <div class="define-table-wrap" :style="{height:config.props.height + 'px'}">
    <div class="defineTable" v-if="showBox">
      <el-table
        :data="chartData"
        style="width: 100%;margin-bottom: 20px;"
        :header-cell-style="customHeaderStyle"
        :row-style="customCellStyle"
        row-key="id"
        :border="config.props.border"
        :stripe="config.props.stripe"
        :show-header="config.props.showHeader"
        :default-expand-all="isExpand"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column
          v-for="(item, index) in tableColumn"
          align="center"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.auto"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      showBox: true
    }
  },
  computed: {
    tableData () {
      let temp = JSON.parse(JSON.stringify(this.chartData))
      return temp
    },
    tableColumn () {
      let temp = this.config.tableColumn
      temp = temp.map((item, idx) => {
        return {
          id: idx + 1,
          label: item.children[0].value,
          prop: item.children[1].value,
          width: item.children[2].value
        }
      })
      return temp
    },
    isExpand () {
      this.updateOptions()
      return this.config.props.isExpand
    }
  },
  mounted () {
  },
  methods: {
    customHeaderStyle () {
      return {
        background: this.config.props.headerCellStyle.background,
        fontSize: this.config.props.headerRowStyle.fontSize
      }
    },
    customCellStyle () {
      return {
        fontSize: this.config.props.cellStyle.fontSize
      }
    },
    updateOptions () {
      this.showBox = false
      setTimeout(() => {
        this.showBox = true
      }, 60)
    }
  }
}
</script>

<style lang="stylus">
.define-table-wrap
  overflow-y auto
  padding 10px 0
  .defineTable
    .el-table--border, .el-table--group
      border 1px solid #241f3d
    .el-table--border::after, .el-table--group::after, .el-table::before
      background none
    .el-table th
      background-image linear-gradient(90deg,#005eff,#1896ff)
      color #ffffff
      text-align center
    .el-table tr
      background #1a1533
    .el-table td
      color #a5a5b4
    .el-table td, .el-table th.is-leaf
      border-bottom 1px solid #241f3d
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
      border-right 1px solid #241f3d
    .el-table td, .el-table th
      padding 8px 0
    .el-table::before
      background-color #191c21
    .el-table--enable-row-hover .el-table__body tr:hover>td
      background-color #1f1e44
    .el-table--striped .el-table__body tr.el-table__row--striped td
      background #1f1e44
    .el-table__empty-block
      background #201e44
    .el-table--scrollable-x .el-table__body-wrapper
      overflow-x hidden
    .el-table, .el-table__expanded-cell
      background none
    .el-table--scrollable-y .el-table__body-wrapper
      &::-webkit-scrollbar
        width: 0.75rem;
        height: 0.75rem;
        background-color: #F5F5F5;
      &::-webkit-scrollbar-track
        box-shadow: inset 0 0 0.375rem #999;
        border-radius: 0.625rem;
        background-color: #F5F5F5;
      &::-webkit-scrollbar-thumb
        border-radius: 0.625rem;
        box-shadow: inset 0 0 0.375rem #999;
        background-color: #333;
.define-table-wrap
  .defineTable.isSpaced
    .el-table th,td
      padding 0!important
    .el-table .cell
      line-height initial
</style>

<style>
.define-table-wrap::-webkit-scrollbar {
  width: 12px;               /* width of the entire scrollbar */
}
.define-table-wrap::-webkit-scrollbar-track {
  background: #0b0b1e;        /* color of the tracking area */
}
.define-table-wrap::-webkit-scrollbar-thumb {
  background-color: #282828;    /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
  border: 3px solid #0b0b1e;  /* creates padding around scroll thumb */
}
</style>
